const Prefooter = ({ showTradeMarkDisclaimer = false }) => {
  return (
    <div className="flex flex-col bg-misc-gray w-full pb-[24px] px-[16px]">
      <p className="text-black text-[12px] pt-[40px] pb-[24px] mx-auto ">
      {disclosureDetails.description}
      </p>
      {showTradeMarkDisclaimer ? (
        <p className="text-black  text-[12px]   mx-auto ">
        {disclosureDetails.additionalDescription}
        </p>
      ) : null}
    </div>
  );
};

export default Prefooter;
